<template>
    <!-- 基本燈箱樣式 -->
    <div class="modal items-center" :class="{ 'modal-open': visiblePopup }">
        <!-- xs:max-w-[23.375rem] -->
        <div class="modal-box p-4 rounded" style="max-width:none" :class="modalWidth">
            <div v-if="visiblePopup">
                <button v-if="closeicon" class="btn btn-circle btn-ghost border-0 absolute right-1 top-1"
                    @click="handleClose">
                    <SvgIcon icon-name="close" class="text-gray-400 w-6 h-6 cursor-pointer" />
                </button>
                <div class="pb-2.5 text-[0.93rem] xs:text-base text-gray-700 border-b border-gray-100">
                    <slot name="content">
                        <div class="flex items-center justify-center">
                            <video ref="video" :width="setWidth()" :height="setWidth() * 0.65"
                                :style="{ height: setWidth() * 0.75 + 'px' }" playsinline="true"
                                webkit-playsinline="true" disablePictureInPicture
                                controlslist="nodownload nofullscreen noremoteplayback"
                                @loadedmetadata="loadedmetadata" />
                        </div>
                        <div v-html="params.content" />
                    </slot>
                </div>
                <div class="modal-action mt-0 pt-2 flex flex-wrap justify-end">
                    <slot name="action">
                        <button v-if="params.cancelButton" class="btn btn-accent rounded-full"
                            @click.stop="$emit('cancel')">
                            {{ params.cancelButton }}
                        </button>
                        <button v-if="params.confirmButton" class="btn rounded-full"
                            :class="[params.isDisabledButton ? 'btn-accent' : params.isErrorButton ? 'btn-error' : 'gradient-primary']"
                            :disabled="params.isDisabledButton" @click.stop="confirm">
                            {{ params.confirmButton }}
                        </button>
                    </slot>
                </div>
            </div>
        </div>
        <Loading :is-loading="isLoading" />
    </div>
</template>
<script>
import { closeVideo, saveImageToBlob } from '@/utils/js/takingPhotoUtils';
import { disableScroll, enableScroll } from '@/utils/style/fixedBodyScroll';
import { openPopup, openPopupCatchMessage } from '@/utils/vfmUtils';
import { onBeforeUnmount, onUnmounted, ref, watchEffect } from 'vue';
import Loading from '@/components/Loading.vue';

export default {
    props: {
        visiblePopup: {
            type: Boolean,
            default: false,
        },
        closeicon: {
            type: Boolean,
            default: false,
        },
        overlayClose: { // 點擊遮罩關閉
            type: Boolean,
            default: false,
        },
        modalWidth: {
            type: String,
            // default: 'max-w-[90%] xs:max-w-[23.375rem]',
            default: '',
        },
        params: {
            type: Object,
            default: () => {
                return {
                    title: '請確認',
                    content: '',
                    confirmButton: '拍攝', // 不傳不顯示
                    isErrorButton: false, // 確認是紅色按鈕嗎？紅色：藍色
                    isDisabledButton: false,
                    cancelButton: '取消',
                };
            },
        },
    },
    components: {
        Loading: Loading,
    },
    emits: ['update:visiblePopup', 'handleClose', 'confirm', 'cancel'],
    setup(props, { emit }) {
        const visible = ref(false);
        const video = ref(null);
        const isLoading = ref(false);

        const initWebRtc = () => {
            isLoading.value = true;
            if (window.navigator.mediaDevices?.getUserMedia) {
                navigator.mediaDevices.getUserMedia({
                    audio: false,
                    video: {
                        deviceId: 'default',
                        // facingMode: "user", //前
                        facingMode: 'environment', // 後
                    },
                }).then((stream) => {
                    video.value.srcObject = stream;
                    video.value.play();
                }).catch((err) => {
                    console.log('nono', err)
                    openPopupCatchMessage(err);
                }).finally(() => { isLoading.value = false });
            } else {
                openPopup('您的裝置目前無法拍攝，請稍後再試');
            }
        };

        const closeWebRtc = () => {
            closeVideo(video.value);
            // closeRecordRTC(recorder);
        };

        onUnmounted(() => {
            enableScroll();
        });

        onBeforeUnmount(() => {
            closeWebRtc();
        });

        watchEffect(() => {
            visible.value = props.visiblePopup;
            visible.value ? disableScroll() : enableScroll();
            if (video.value && visible.value) {
                initWebRtc();
            }

            if (!visible.value) {
                closeWebRtc();
            }
        });

        const handleClose = () => {
            emit('handleClose');
        };

        const confirm = () => {
            if (video.value === null) {
                return;
            }

            saveImageToBlob(video.value).then(e => {
                closeWebRtc();
                emit('confirm', e);
            });
        };
        const setWidth = () => {
            return window.innerHeight < window.innerWidth ? window.innerHeight : window.innerWidth;
        };

        const loadedmetadata = () => {
            console.log('loadedmetadata', video.value.offsetWidth, video.value.offsetHeight);
            // video.value.width = video.value.offsetWidth;
            // video.value.height = video.value.offsetHeight;
        };
        return {
            visible,
            handleClose,
            props,
            video,
            confirm,
            loadedmetadata,
            setWidth,
            isLoading
        };
    },
};
</script>

<style lang="scss" scoped>
:deep(.modal-box) {
    @apply max-h-screen;
}

:deep(.modal-action) {
    button {
        @apply ml-0.5 mt-1;

        &:first-child {
            @apply ml-0;
        }
    }
}

.modal {
    z-index: 500;
}
</style>
